import { render, staticRenderFns } from "./ConfirmDeactivation.vue?vue&type=template&id=df468174"
import script from "./ConfirmDeactivation.vue?vue&type=script&lang=js"
export * from "./ConfirmDeactivation.vue?vue&type=script&lang=js"
import style0 from "./ConfirmDeactivation.vue?vue&type=style&index=0&id=df468174&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports